import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import get from 'lodash.get';
import UserAmountsPanel from './UserAmountsPanel';
import CreditRating from '../../components/CreditRating';
import { geti18n } from '../../utils';
import BestOfferList from './BestOfferList';
import LeadsForm, { FIELD_NAMES } from '../../components/LeadsForm';
import Accordion from '../../components/Accordion';
import DealersList from '../../components/DealersList';
import NextStepsWrapper from '../../components/NextStepsWrapper';
import { resetLead, submitLead } from '../../redux/actions/leads';
import { isLeadSubmitSuccessful, getLeadError } from '../../redux/selectors/leads';
import Modal from '../../components/Modal';
import FormThankYou from '../../components/FormThankYou';
import { getActiveTrimYear, } from '../../redux/selectors/trim';
import { getActiveModelLineFullName } from '../../redux/selectors/models';
import ErrorModal from '../../components/ErrorModal';
import {
  selectTrimTitle,
  getNavigationObject,
  getEnvironmentObject,
  getHostFromState,
  getVisitorIdFromState
} from '../../redux/selectors';

/**
 * Trim View Displays the Payment Options available to the user for the selected
 * Model line and Trim. The user can enter amounts into the User Amounts Panel
 * to manipulate the options and change their selection with the model/trim selects
 */

// case matters, ex. "state" is correct not "State" b/c the api is not consistent
const FORM_FIELDS_TO_LEAD_MAP = {
  firstName: FIELD_NAMES.FIRST_NAME,
  lastName: FIELD_NAMES.LAST_NAME,
  streetNumber: FIELD_NAMES.ADDRESS,
  city: FIELD_NAMES.CITY,
  state: FIELD_NAMES.STATE,
  postalCode: FIELD_NAMES.ZIP_CODE,
  email: FIELD_NAMES.EMAIL,
  emailOptIn: FIELD_NAMES.NEWS,
  phone: FIELD_NAMES.PHONE
};

const FORM_FIELD_LEADS_PRE_PROCESSING = {
  phone: phone => (phone ? phone.replace(/[^0-9]/g, '') : phone)
};

class TrimView extends Component {
  static propTypes = {
    navigation: PropTypes.object.isRequired,
    environment: PropTypes.object.isRequired,
    submitLeadAction: PropTypes.func.isRequired,
    resetLeadAction: PropTypes.func.isRequired,
    host: PropTypes.string.isRequired,
    year: PropTypes.string.isRequired,
    visitorId: PropTypes.string.isRequired,
    leadSubmitted: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool
    ]).isRequired,
    leadsError: PropTypes.object,
    thankYouTitle: PropTypes.string,
    thankYouContent: PropTypes.string,
    zipErrorTitle: PropTypes.string,
    zipErrorContent: PropTypes.string,
    genericErrorTitle: PropTypes.string,
    genericErrorContent: PropTypes.string,
    leadFormAccordionTitle: PropTypes.string,
    leadFormAccordionState: PropTypes.bool,
    modelLineFullName: PropTypes.string.isRequired,
  };

  static defaultProps = {
    thankYouTitle: geti18n('leadsFormContent.trimViewPage.thankYouTitle'),
    thankYouContent: geti18n('leadsFormContent.trimViewPage.thankYouContent'),
    zipErrorTitle: geti18n('leadsFormContent.trimViewPage.zipErrorTitle'),
    zipErrorContent: geti18n('leadsFormContent.trimViewPage.zipErrorContent'),
    genericErrorTitle: geti18n('leadsFormContent.trimViewPage.genericErrorTitle'),
    genericErrorContent: geti18n('leadsFormContent.trimViewPage.genericErrorContent'),
    leadFormAccordionState: geti18n('accordionDrawers.2.accordionOpen'),
    leadFormAccordionTitle: geti18n('accordionDrawers.2.title'),
    leadsError: {},
    year: '',
    modelLineFullName: ''
  }

  constructor() {
    super();
    this.state = { formValues: null, dealer: null };
  }

  currentFormValues = (values) => {
    this.props.resetLeadAction(); // reset so we can goto the next step
    this.setState({ formValues: values });
  };

  currentDealer = (dealer) => {
    if (dealer && dealer.dealerId && this.state.formValues) this.compileLeadData(dealer);
    this.setState({ dealer });
  };

  compileLeadData = (dealer) => {
    const customerData = this.mapFormToLeadData(this.state.formValues);
    this.submitLead(
      customerData,
      dealer,
      {}
    );
  };

  mapFormToLeadData(formValues) { //eslint-disable-line
    return Object.keys(FORM_FIELDS_TO_LEAD_MAP).reduce((leadsObj, leadKey) => {
      const formKey = FORM_FIELDS_TO_LEAD_MAP[leadKey];
      const formValue = get(formValues, formKey);
      const fieldPreProcessor = get(FORM_FIELD_LEADS_PRE_PROCESSING, leadKey);
      if (formValue) {
        leadsObj[leadKey] = fieldPreProcessor ? fieldPreProcessor(formValue) : formValue; //eslint-disable-line
      }

      return leadsObj;
    }, {});
  }

  submitLead = (customerData, dealer) => {
    const {
      navigation,
      environment,
      host,
      year,
      visitorId,
      submitLeadAction,
      modelLineFullName
    } = this.props;
    const make = environment.BRAND_CHANNEL;
    const language = environment.LANG;
    const requestObject = ({
      customer: {
        ...customerData,
        language,
        visitorId
      },
      dealer: {
        dealerId: dealer.dealerId,
        dealerName: dealer.dealerName,
        dealerZipCode: dealer.dealerZip
      },
      vehicle: {
        make,
        model: modelLineFullName,
        trimDescription: navigation.trimSlug,
        year,
        vehicleCode: navigation.modelLineCode
      },
      host,
      leadCaptureDate: new Date().toISOString(),
    });
    submitLeadAction(requestObject);
  };

  render() {
    const {
      leadSubmitted,
      resetLeadAction,
      leadsError,
      thankYouTitle,
      thankYouContent,
      zipErrorTitle,
      zipErrorContent,
      genericErrorContent,
      genericErrorTitle,
      leadFormAccordionState,
      leadFormAccordionTitle,
    } = this.props;
    const showDealerList = this.state.formValues;
    let modalView = leadSubmitted ?
      <FormThankYou title={thankYouTitle} content={thankYouContent} />
      :
      <DealersList currentFormValues={this.state.formValues} currentDealer={this.currentDealer} />
    if (leadsError) {
      if (leadsError === 'zipCodeMismatchError') {
        modalView = (<ErrorModal
          title={zipErrorTitle}
          content={zipErrorContent}
        />)
      } else {
        modalView = (<ErrorModal
          title={genericErrorTitle}
          content={genericErrorContent}
        />)
      }
    }
    /* eslint-disable */
    return (
      <section>
        <CreditRating />
        <UserAmountsPanel />
        <div className="row margin-bottom-small">
          <BestOfferList />
        </div>
        <Accordion title={leadFormAccordionTitle} id="leads-form" open={leadFormAccordionState} >
          <NextStepsWrapper noBg={true} moreMarginBottom={showDealerList}>
            <LeadsForm
              className="payment-estimator-leads-form"
              currentFormValues={this.currentFormValues}
            />
            {
              showDealerList ? (
                <span>
                  <Modal onClose={resetLeadAction} contentLabel='test' disableClose={false} isModalOpen={showDealerList} modalStyles={{ 'maxWidth': '1100px', 'minWidth': '320px' }}>
                    {modalView}
                  </Modal>
                </span>
              ) : ''
            }
          </NextStepsWrapper>
        </Accordion>
      </section>
    );
  }
}
/* eslint-enable */
/**
 * Maps the selected trim to the title of the page
 * @param state - The Redux state
 */
const mapStateToProps = state => ({
  title: selectTrimTitle(state),
  navigation: getNavigationObject(state),
  environment: getEnvironmentObject(state),
  year: getActiveTrimYear(state),
  host: getHostFromState(state),
  visitorId: getVisitorIdFromState(state),
  leadSubmitted: isLeadSubmitSuccessful(state),
  leadsError: getLeadError(state),
  modelLineFullName: getActiveModelLineFullName(state)
});

const mapDispatchToProps = dispatch => ({
  submitLeadAction: bindActionCreators(submitLead, dispatch),
  resetLeadAction: bindActionCreators(resetLead, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(TrimView);




/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/index.js
 **/